import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const CourseLeaderRecord = Record({
  name: '',
  subtitle: '',
  description: '',
  photo: '',
  link: '',
});

export default class CourseLeader extends CourseLeaderRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {};

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new CourseLeader(hydrated);
  }
}
